import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";

// core components

import componentStyles from "assets/theme/components/headers/simple-header.js";

const useStyles = makeStyles(componentStyles);

const DoobiHeader = ({ section, subsection }) => {
  const classes = useStyles();
  return (
    <>
      <div className={classes.header}>
        <Container
          maxWidth={false}
          component={Box}
          classes={{ root: classes.containerRoot }}
        >
          {/*
            This header renders nothing -- it is purely a spacer, and its
            height is what separates the page content from the top of the
            layout. The header's own paddingBottom cancels against the -4.5rem
            marginTop every consuming view applies, so the visible gap is
            simply twice the padding below:

              2 x 0.5rem = 1rem (16px) above the page card

            Deliberately tighter than the 30px left/right padding on
            containerRoot -- the full 30px read as too airy at the top, and
            the original 1.5rem left 48px.
          */}
          <Grid
            container
            component={Box}
            alignItems="center"
            paddingTop="0.5rem"
            paddingBottom="0.5rem"
          >
          </Grid>
        </Container>
      </div>
    </>
  );
};

DoobiHeader.propTypes = {
  section: PropTypes.string
};

export default DoobiHeader;
